import { Component } from '@angular/core';
import { AutorizacionService } from './services/autorizacion.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  /* al gestionar la barra de navegacion ocultamos o mostramos la seccion de login y registro */
  loggedIn=false;
  emailUser:any=null;
  // imagen por defecto en el hedaer
  imgHeader:string=null;
  
  constructor(private autorizacionService:AutorizacionService){
    this.imgHeader='http://www.trilogic.me/public-assets/icono1.png';

    this.autorizacionService.isLogged()
      .subscribe((result)=>{
        // puede existir resultado pero ususario no esta logueado
        if(result && result.uid){
          this.loggedIn = true;
          this.emailUser = this.autorizacionService.getEmailUser();
          // validar que obtenga alguna imagen a mostrar 
          let photo = this.autorizacionService.getUrlPhoto();
          if (photo!=null || photo !=''){
            // asignar
            this.imgHeader=photo;
            console.log("app indicator :::::::::::::::::::::::::::::::::::::::::::");
          }
          //debugger;
          // mostrar imagen
        }else{
          this.loggedIn=false;
        }
      }, (error)=>{
        this.loggedIn=false;
      })
  }

  // Métodos adicionales
  logOutUser(){
    this.autorizacionService.logOut();
  }
}



// WEBPACK FOOTER //
// C:/Users/USUARIO/Documents/Platzi/cursos__2017/Angular_4_PROFESIONAL/proyectos/platzisquare2/src/app/app.component.ts